import { render, staticRenderFns } from "./PageNavigator.vue?vue&type=template&id=18bab044&"
import script from "./PageNavigator.vue?vue&type=script&lang=js&"
export * from "./PageNavigator.vue?vue&type=script&lang=js&"
import style0 from "./PageNavigator.vue?vue&type=style&index=0&id=18bab044&prod&lang=css&"
import style1 from "./PageNavigator.vue?vue&type=style&index=1&id=18bab044&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBadge,VBtn,VCard,VCardText,VCol,VDivider,VMenu,VRow})
